// @flow

import React from 'react';
import { withRouter } from 'react-router';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import type { RouterHistory } from 'react-router';

type PropsType = {
    history: RouterHistory,
};

const HOME_SURFACES = [
    {
        key: 'operations',
        eyebrow: 'Monitoring',
        title: 'Operations overview',
        description: 'Use the live operations view to inspect guest activity, payment issues, completed bill volume, and loyalty events.',
        route: '/operations-dashboard',
        action: 'Open operations overview',
    },
    {
        key: 'restaurants',
        eyebrow: 'Restaurants',
        title: 'Restaurant activity',
        description: 'Scan location-by-location health, recent revenue, attention transactions, and assistance load across active restaurants.',
        route: '/restaurant-activity',
        action: 'Open restaurant activity',
    },
    {
        key: 'support',
        eyebrow: 'Support',
        title: 'Support hub',
        description: 'Triage payment exceptions, bill intervention risk, and support requests from the dedicated support workflow surface.',
        route: '/support-monitor',
        action: 'Open support hub',
    },
];

function BackofficeCommandCenterHome({ history }: PropsType) {
    return (
        <div className="operations-page" data-testid="backoffice-command-center-home">
            <div className="operations-hero command-center-hero compact">
                <div>
                    <div className="operations-kicker">Backoffice command center</div>
                    <h1 className="operations-title">Choose the surface you want to operate</h1>
                    <p className="operations-subtitle">
                        The home page is the operator landing area. Use it to jump into the dedicated monitoring, restaurant, and support screens instead of treating one dashboard as everything.
                    </p>
                </div>
                <div className="operations-hero-actions">
                    <Button color="primary" onClick={() => history.push('/operations-dashboard')}>
                        Go to operations overview
                    </Button>
                    <Button color="secondary" outline onClick={() => history.push('/launch-status')}>
                        Open launch status
                    </Button>
                </div>
            </div>

            <Row>
                {HOME_SURFACES.map((surface) => (
                    <Col lg="4" key={surface.key} className="bottom-spaced-element">
                        <Card className="dashboard-card command-center-card h-100">
                            <CardBody>
                                <div className="dashboard-card-label">{surface.eyebrow}</div>
                                <div className="command-center-card-title">{surface.title}</div>
                                <div className="dashboard-card-help">{surface.description}</div>
                                <Button color="secondary" outline className="command-center-card-action" onClick={() => history.push(surface.route)}>
                                    {surface.action}
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
}

export default withRouter(BackofficeCommandCenterHome);